export default __webpack_public_path__ + "static/media/med.87684c17.svg";